import React, { useState } from 'react'
import CallForm from './contact-form/call-form.component'
import MapForm from './contact-form/map.component'
import { FaPhoneAlt, FaMapMarkerAlt, FaWhatsapp, FaInstagram, FaTwitter, FaEnvelope, } from 'react-icons/fa'
import { Row, Container, Col, Button } from 'react-bootstrap'
import MailForm from './contact-form/contact-form.components';
import './styles.scss'

function Contact() {
    const [loadContactForm, setloadContactForm] = useState(<MailForm />)

    return (
        <div className="contact" id="Contact">
            <Container>
                <Row className="ContactDiv">
                    <Col sm={12} lg={6} className="ContactLeft">
                        <div>
                            <h1>Contact</h1>
                            <p>Message or Mail us, we will contact you in 24 hours</p>
                        </div>
                        <div>
                            <Button className="Btn" onClick={() => setloadContactForm(<CallForm />)} ><FaPhoneAlt />&nbsp;&nbsp;&nbsp;Phone Call</Button><br />
                            <Button className="Btn" onClick={() => setloadContactForm(<MailForm />)} ><FaEnvelope />&nbsp;&nbsp;&nbsp;Mail us</Button><br />
                            <Button className="Btn" onClick={() => setloadContactForm(<MapForm />)} ><FaMapMarkerAlt />&nbsp;&nbsp;&nbsp;Map Location</Button>
                        </div>
                        <div>
                            <Col sm={12} lg={6} style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <Button className="Button" as='a' target="_blank" rel="noreferrer" href="https://www.twitter.com/techseminal"><FaTwitter style={{ color: '#fff' }} /></Button>
                                <Button className="Button" as='a' target="_blank" rel="noreferrer" href="https://www.instagram.com/techseminal"><FaInstagram style={{ color: '#fff' }} /></Button>
                                <Button className="Button" as='a' target="_blank" rel="noreferrer" href="https://chat.whatsapp.com/CFyz8jn6e7bGhLDOinljLv"><FaWhatsapp style={{ color: '#fff' }} /></Button>
                            </Col>
                        </div>
                    </Col>
                    <Col sm={12} lg={6} className="ContactRight">
                        {loadContactForm}
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default Contact
